__turbopack_context__.v({
  "boxOne": "bento-rectangle-testimonial-module-scss-module__Pf_Eya__boxOne",
  "boxOneContent": "bento-rectangle-testimonial-module-scss-module__Pf_Eya__boxOneContent",
  "boxOneCopy": "bento-rectangle-testimonial-module-scss-module__Pf_Eya__boxOneCopy",
  "center": "bento-rectangle-testimonial-module-scss-module__Pf_Eya__center",
  "heading": "bento-rectangle-testimonial-module-scss-module__Pf_Eya__heading",
  "headinggradient": "bento-rectangle-testimonial-module-scss-module__Pf_Eya__headinggradient",
  "right": "bento-rectangle-testimonial-module-scss-module__Pf_Eya__right",
  "subheading": "bento-rectangle-testimonial-module-scss-module__Pf_Eya__subheading",
  "subtitle": "bento-rectangle-testimonial-module-scss-module__Pf_Eya__subtitle",
  "vertical": "bento-rectangle-testimonial-module-scss-module__Pf_Eya__vertical",
});
